export default __webpack_public_path__ + "static/media/digital-identity-mobile.872c8784.svg";